import { IGetState, TBoardId } from '../../../../../../../../../types/types';
import { Dispatch, ThunkAction } from '../../../../../../../../../types/actions';
import { setVersion } from '../../../../../../../../../rest/effects/board/setVersion';
import { EBoardVersion } from '../../../../../../../../../types/rest/IRestDashboard';
import {
    PWC_OPEN_FILE_MIME_FILTER
} from '../../../../../../../dialogs/openBoards/FooterImport/hocs/FooterImportHOC/constants';
import { onDriveDocSelect } from '../effects/onDriveDocSelect';
import { getAuthUser } from '../../../../../../../../../store/model/authUser/selectors/getAuthUser';
import { DriveItem } from '@microsoft/microsoft-graph-types';
import { TXMLRestoreDoc } from '../../../../../../../dialogs/openBoards/hocs/FooterRestoreXmlHOC/effects/types';
import {
    selectFileFromLocalDrive
} from '../../../../../../../../../helper/authorisation/microsoft/selectFileFromLocalDrive/selectFileFromLocalDrive';
import { EAuthUserPlatformType } from '../../../../../../../../../types/rest/IRestAuthUser';

export const onTemplatePwcImportSelect = (
    boardId: TBoardId,
): ThunkAction => {
    const action = (
        dispatch: Dispatch,
        getState: IGetState
    ) => {
        dispatch(setVersion(EBoardVersion.V4, boardId)).then(() => {
            const state = getState();
            const { appFolderInfo, platformType } = getAuthUser(state);

            const onFinish = (docs: TXMLRestoreDoc[]) => {
                console.log(docs[0]);
                dispatch(onDriveDocSelect(docs[0].id, docs[0].driveId, boardId));
            };

            if (platformType === EAuthUserPlatformType.MICROSOFT) {
                selectFileFromLocalDrive(
                    appFolderInfo.driveId,
                    appFolderInfo.folderId,
                    false,
                    ['.csv'],
                    () => {},
                    percent => {}
                ).then((driveItems: DriveItem[]) => {
                    if (!driveItems || !driveItems.length) return null;

                    let item = driveItems[0];
                    let docs: TXMLRestoreDoc[] = [{
                        id: item.id,
                        driveId: item.parentReference.driveId,
                        name: item.name
                    }];

                    onFinish(docs);
                });
            } else {
                App.Helpers.googleDriveOpenDialogue.showByMimeTypes(
                    false,
                    PWC_OPEN_FILE_MIME_FILTER,
                    onFinish
                );
            }
        });
    };
    return action;
};
